import React, { useEffect,useState } from 'react';
import '../../../styles/custom-drawer.scss';
import CloseIcon from '@material-ui/icons/Close';
import CLQProgressBar from '../CLQProgressBar/CLQProgressBar';
import PropertyLocation from '../../pages/Forms/PropertyLocation';
import VerifyHouse from '../../pages/Forms/VerifyHouse';
import MoreInfo from '../../pages/Forms/MoreInfo';
import FinanceHistory from '../../pages/Forms/FinanceHistory';
import Association from '../../pages/Forms/Association';
import Condition from '../../pages/Forms/Condition';
import AboutHouse from '../../pages/Forms/AboutHouse';
import HomeImprovements from '../../pages/Forms/HomeImprovements';
import Built from '../../pages/Forms/Built';
import HomeFeatures from '../../pages/Forms/HomeFeatures';
import HomeView from '../../pages/Forms/HomeView';
import FlooringTypes from '../../pages/Forms/FlooringTypes';
import KitchenCountertops from '../../pages/Forms/KitchenCountertops';
import SellHome from '../../pages/Forms/SellHome';
import PlaningHome from '../../pages/Forms/PlaningHome';
import HomeConcern from '../../pages/Forms/HomeConcern';
import SendOffer from '../../pages/Forms/SendOffer';
import RealEstatAgent from '../../pages/Forms/RealEstateAgent';
import LoanOfficer from '../../pages/Forms/LoanOfficer';
import HowDidYouHearAbout from '../../pages/Forms/HowDidYouHearAbout';
import NewHome from '../../pages/Forms/NewHome';
import Defects from '../../pages/Forms/Defects';
import Issues from '../../pages/Forms/Issues';
import Septic from '../../pages/Forms/Septic';
import DownPaymentEquity from '../../pages/Forms/DownPaymentEquity';

export default function CustomDrawer(props) {
    const [pageNumber,setPageNumber] = useState(1);
    const [showCaptcha,setShowCaptcha] = useState(true);
    const [submitResponse, setSubmitResponse] = useState(null);
    const [isDefects, setIsDefects] = useState();
    const [selectedLo,setSelectedLo] = useState();
    const [selectedAgent,setSelectedAgent] = useState();
    const [loanOfficerSelected, setLoanOfficerSelected] = useState(null)
    const [agentSelected, setAgentSelected] = useState(null)
    const [isDisabledLo,setIsDisabledLo] = useState(false);
    const [isDisabledAgent,setIsDisabledAgent] = useState(false);

    const onPageChange = (e) =>{
        props.setPageNumber(e);
    }

    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function (event) {
            window.history.go(1);
        };
    }, [])

    return (
        <div>
            <div className={`calque-drawer w-100 drawer-transition ${props.cdrawer === true ? 'drawer-visible' : 'drawer-not-visible'}`}>
                <div className={`calque-drawer-form`}>
                    <div className={`calque-drawer-form-page`}>
                        <div className={`form-progress`}>
                            <div className="primary-background text-white h-100" style={{ backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
                                <div className="px-5 py-2 d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-end">
                                        <h3 className="m-0 p-0 jost-bold">Get My Estimate</h3>
                                    </div>
                                    <div>
                                        <span className="cursor-pointer" onClick={props.drawerHandleClose}>
                                            <CloseIcon />
                                        </span>
                                    </div>
                                </div>
                                <div className="px-5 py-2">
                                    <CLQProgressBar {...props} progress={props.progress} />
                                </div>
                            </div>
                        </div>
                        <div className={`form-section-fields`} id="scroll-event" onScroll={props.handleScroll}>
                            {props.pageNumber === 1 &&
                            <div className={`position-relative`}>
                                <div className={`form-section-header white-background d-flex`} style={{ zIndex: '2' }} id="eligibility_section">
                                    <div className="px-5 d-flex align-items-center">
                                        <h6 className="section-heading m-0">ELIGIBILITY</h6>
                                    </div>
                                </div>

                                <div className={`form-field`}>
                                    {props.location !== true ?
                                        ''
                                        :
                                        <>
                                            <div className="px-5" id="owner">
                                                <div>
                                                    <PropertyLocation {...props} submitResponse={submitResponse} handleNext={props.handleNext} getEstimateButton={props.getEstimateButton} validateDisplay18={props.validateDisplay18} location={props.location} />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className={props.location === true ? 'px-5' : 'px-5'} id="verify">
                                        <div className={props.location === true ? 'pt-4' : 'pt-1'}>
                                            <VerifyHouse {...props} handleNext={props.handleNext} />
                                        </div>
                                    </div>
                                    <div className="px-5" id="moreinfo">
                                        <div className={`question pt-4`}>
                                            <MoreInfo {...props} handleNext={props.handleNext} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"financehistory"}>
                                        <div className={`question`}>
                                            <FinanceHistory {...props} handleNext={props.handleNext} displayPropertyLoc={props.displayPropertyLoc} errors={props.errors} touched={props.touched} setFieldValue={props.setFieldValue} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"association"}>
                                        <div className={`question pt-3`}>
                                            <Association {...props} handleNext={props.handleNext} displayPropertyLoc={props.displayPropertyLoc} errors={props.errors} touched={props.touched} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"newhome"}>
                                        <div className={`question pt-3`}>
                                            <NewHome {...props} handleNext={props.handleNext} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"downpaymentequity"}>
                                        <div className={`question pt-3`}>
                                            <DownPaymentEquity {...props} handleNext={props.handleNext} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"loanofficer"}>
                                        <div className={`question pt-3`}>
                                            <LoanOfficer {...props} handleNext={props.handleNext} selectedLo={selectedLo} setSelectedLo={setSelectedLo} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} setIsDisabledLo={setIsDisabledLo} isDisabledLo={isDisabledLo} partnerContactRole={props.partnerContactRole} loanOfficerSelected={loanOfficerSelected} setLoanOfficerSelected={setLoanOfficerSelected}/>
                                        </div>
                                    </div>
                                    <div className="px-5" id={"realestate"}>
                                        <div className={`question pt-3`}>
                                            <RealEstatAgent {...props} handleNext={props.handleNext} selectedAgent={selectedAgent} setSelectedAgent={setSelectedAgent}
                                            setIsDisabledAgent={setIsDisabledAgent} isDisabledAgent={isDisabledAgent} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} propertyID={props.propertyID} agentSelected={agentSelected} setAgentSelected={setAgentSelected} setPropertyID={props.setPropertyID} GAtimer={props.GAtimer} setGaUserNotAnswered={props.setGaUserNotAnswered} partnerContactRole={props.partnerContactRole} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"howdidyouhear"}>
                                        <div className={`question pt-3`}>
                                            <HowDidYouHearAbout {...props} setSubmitResponse={setSubmitResponse} submitResponse={submitResponse} handlePageChange={onPageChange} pageNumber={props.pageNumber} showCaptcha={showCaptcha} handleNext={props.handleNext} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} propertyID={props.propertyID} setPropertyID={props.setPropertyID} GAtimer={props.GAtimer} setGaUserNotAnswered={props.setGaUserNotAnswered} aboutUsList={props.aboutUsList} click_id={props.click_id} gclid={props.gclid} linked_in={props.linked_in} lead_activity_id={props.lead_activity_id} facebook_pixel={props.facebook_pixel} setCaptchaValue={props.setCaptchaValue} captchaValue={props.captchaValue} validateDisplay10={props.validateDisplay10} old_address={props.old_address} old_property_type_id={props.old_property_type_id} />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {/* {(props.propertyID || props.values.property_id) === null ? '' :
                                <> */}
                            {props.pageNumber === 2 && 
                            <div className={`position-relative`}>
                                <div className={`form-section-header white-background d-flex`} style={{ zIndex: '2' }} id="homefacts_section">
                                    <div className="px-5 d-flex align-items-center">
                                        <h6 className="section-heading m-0">HOME FACTS</h6>
                                    </div>
                                </div>
                                <div className="px-5" id={"built"}>
                                    <div className={`question pt-4`}>
                                        <Built {...props} submitResponse={submitResponse} pageNumber={props.pageNumber} handleNext={props.handleNext} errors={props.errors} touched={props.touched} />
                                    </div>
                                </div>
                                <div className="px-5" id={"defects"}>
                                    <div className={`question pt-3`}>
                                        <Defects {...props} isDefects={isDefects} setIsDefects={setIsDefects} defectsList={props.defectsList}/>
                                    </div>
                                </div>
                                <div className="px-5" id={"issues"}>
                                    <div className={`question pt-3`}>
                                        <Issues {...props} conditionList={props.conditionList}/>
                                    </div>
                                </div>
                                <div className="px-5" id={"septic"}>
                                    <div>
                                        <Septic {...props}/>
                                    </div>
                                </div>
                                <div className="px-5" id={"condition"}>
                                    <div className={`question pt-3`}>
                                        <Condition {...props} handlePageChange={onPageChange} showCaptcha={setShowCaptcha} handleNext={props.handleNext} errors={props.errors} touched={props.touched} ValidateFinalError={props.ValidateFinalError} condition={props.condition} />   
                                    </div>
                                </div>
                            </div>}
                            {props.pageNumber === 3 &&
                            <div className={`position-relative`}>
                                <div className={`form-section-header white-background d-flex`} style={{ zIndex: '2' }} id="preference_section">
                                    <div className="px-5 d-flex align-items-center">
                                        <h6 className="section-heading m-0">PREFERENCES</h6>
                                    </div>
                                </div>
                                <div className={`form-field`}>
                                    <div className="px-5" id={"sellhome"}>
                                        <div className={`question`}>
                                            <SellHome {...props} submitResponse={submitResponse} pageNumber={props.pageNumber} handleNext={props.handleNext} errors={props.errors} touched={props.touched} />
                                        </div>
                                    </div>
                                    <div className="px-5" id={"homeconcern"}>
                                        <div className={`question pt-3`}>
                                            <HomeConcern {...props} handleNext={props.handleNext} errors={props.errors} touched={props.touched} />
                                        </div>
                                    </div>
                                    <div className="px-5 pb-5 mb-5" id={"sendoffer"}>
                                        <div className={`question pt-3`}>
                                            <SendOffer {...props} setIsDefects={setIsDefects} handlePageChange={onPageChange} handleNext={props.handleNext} errors={props.errors} touched={props.touched} />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                                {/* </>
                            } */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}